import React from 'react';
import {Switch, Route} from 'react-router-dom';

import HomePage from './HomePage';
import CB11Patch from './CB11Patch';
import CB11Handheld from './CB11Handheld';
import CB12Handheld from './CB12Handheld';
import PageNotFound from './PageNotFound';

const Routes = () => {
	return (
		<Switch>
			<Route exact path = '/' component={HomePage} />
			<Route path = '/cb11-patch' component={CB11Patch} />
			<Route path = '/cb11-handheld' component={CB11Handheld} />
			<Route path = '/cb12-handheld' component={CB12Handheld} />
			<Route render = {() => <PageNotFound />} />
		</Switch>
	);
};

export default Routes;
